import apiService from "./apiService";
import AppConstants from "../appConstants";

class ServiceAccountManagerService {
    getAll(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SERVICE_ACCESS_MANAGER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_SERVICE_ACCESS_MANAGER}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    generateNewToken(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SERVICE_ACCESS_MANAGER_GENERATE_NEW_TOKEN, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    register(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_SERVICE_ACCESS_MANAGER, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    delete(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_SERVICE_ACCESS_MANAGER}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_SERVICE_ACCESS_MANAGER_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new ServiceAccountManagerService();
